import { render, staticRenderFns } from "./excellentCoursesRecommend.vue?vue&type=template&id=3258a612&scoped=true"
import script from "./excellentCoursesRecommend.vue?vue&type=script&lang=js"
export * from "./excellentCoursesRecommend.vue?vue&type=script&lang=js"
import style0 from "./excellentCoursesRecommend.vue?vue&type=style&index=0&id=3258a612&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3258a612",
  null
  
)

export default component.exports